<template>
	<div>
		<v-btn
				color="grey lighten-1"
				class="mr-1"
				x-small
				:disabled="disable"
				icon
				@click="overlay = !overlay"
		>
			<v-icon :color="color">mdi-eye</v-icon>
		</v-btn>
		<v-dialog v-model="overlay">
			<v-card class="d-flex">
				<v-card-actions class="ml-auto">
					<v-btn color="green darken-1" text @click="overlay = false"
					>Close
					</v-btn
					>
				</v-card-actions>
			</v-card>
			<v-card class="d-flex">
				<embed
						class="ml-auto mr-auto mt-6"
						:src="link"
						:width="width"
						:height="height"
				/>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
// services
import { getAppUrl } from "@/services";

export default {
	name: "PreviewDoc",
	props: [ "link-doc", "disable", "color" ],
	data() {
		return {
			overlay: false,
		};
	},
	computed: {
		link() {
			return getAppUrl + this.linkDoc;
		},
		height() {
			return self.innerHeight - 200;
		},
		width() {
			return self.innerWidth - 100;
		},
	},
};
</script>
